
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";

export const NotificationSettingsEmpty = () => {
  return (
    <Alert>
      <AlertCircle className="h-4 w-4" />
      <AlertDescription>
        <div className="flex flex-col gap-3">
          <p className="font-medium">لا توجد إعدادات إشعارات متاحة حالياً.</p>
          <p className="text-sm text-gray-600">
            إذا استمرت هذه المشكلة، يرجى التواصل مع مسؤول النظام.
          </p>
        </div>
      </AlertDescription>
    </Alert>
  );
};
